import { render, staticRenderFns } from "./UnitShop.vue?vue&type=template&id=520e4665&scoped=true"
import script from "./UnitShop.vue?vue&type=script&lang=js"
export * from "./UnitShop.vue?vue&type=script&lang=js"
import style0 from "./UnitShop.vue?vue&type=style&index=0&id=520e4665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e4665",
  null
  
)

export default component.exports